import { Link } from 'react-router'
import { LuCalendarDays } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { PageHero, heroPrimaryLink } from '@/components/ui/PageHero'
import { patientConsultation } from '@/assets/siteMedia'

export const ConsultationsHero = () => (
  <PageHero
    image={patientConsultation}
    imageAlt="A client in a one-to-one herbal consultation with Kandake"
    imagePosition="object-[25%_40%]"
    highlights={['One-to-one with Kandake', 'Herbs, nutrition & lifestyle', 'Personal call-back']}
    title="Herbal"
    accent="Consultations"
    description={
      <p>
        Personalised one-to-one consultations exploring the root causes of imbalance through herbal
        medicine, nutrition, lifestyle guidance, and holistic wellbeing.
      </p>
    }
  >
    <Link to={`${ROUTES.CONTACT}?service=herbal-consultation`} className={heroPrimaryLink}>
      Book a Consultation
      <LuCalendarDays aria-hidden="true" className="h-4 w-4 shrink-0" />
    </Link>
  </PageHero>
)
